// Route prefixes that do not require a signed-in patient. Everything not listed here redirects to
// /login when the session check fails.

// Rendered whether or not there is a session, but /me is still called so a signed-in patient keeps
// their context - header, service name, PIS state. A 401 just means "show the anonymous view", it
// does not redirect. The PIS gate is skipped too, since the PIS is itself a help centre article.
export const optionalAuthPaths = ["/help"];

// No session check at all - these render before a patient could have one.
export const anonymousPaths = ["/login", "/privacy-policy", "/terms-and-conditions"];

export const isPathIn = (pathname: string, prefixes: string[]) =>
  prefixes.some((p) => pathname === p || pathname.indexOf(`${p}/`) === 0);
